var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDoorInSolid = function SvgDoorInSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66281 5.58591L7.91281 4.03153C8.46516 3.86778 9 4.36247 9 5.03685V6H11.625C12.2454 6 12.75 6.69344 12.75 7.54531V8V17V18H14.625C14.8322 18 15 18.2238 15 18.5V19.5C15 19.7762 14.8322 20 14.625 20H11.25V17V8H9V20H2V18V6.59122C2 6.1156 2.27316 5.70122 2.66281 5.58591ZM6.5 12C6.5 12.5522 6.83594 13 7.25 13C7.66406 13 8 12.5522 8 12C8 11.4478 7.66406 11 7.25 11C6.83594 11 6.5 11.4478 6.5 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6784 14.3011L18.6397 12.987L22 12.987V11.0143L18.6397 11.0143L18.6784 9.6981C18.6784 9.07674 17.9317 8.76655 17.4944 9.20593L15.2038 11.5074C14.9327 11.7798 14.9317 12.2204 15.2028 12.4928L17.4934 14.7943C17.9307 15.2337 18.6784 14.9225 18.6784 14.3011Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoorInSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/door_in_solid.23e25025.svg";
export { ForwardRef as ReactComponent };